import { useState, useEffect } from 'react';
import { SiteDisplayItems, callGetSiteDisplayItemsApi } from 'requests/RequestSite';
import { Store } from 'store/Store';
import { HttpStatus } from 'consts/HttpStatus';

export type SiteDisplayItemsExtend = SiteDisplayItems & {
	isSkip3_2: boolean;
	password_confirm: number;
	birthYear: number;
	birthMonth: number;
	birthDate: number;
};
/**
 * サービスサイト別表示項目に関するカスタムフック
 * @params shareDiaplayItems 初回読み込み以外の場合の、初回に取得したデータ
 */
export const useSiteDisplayItems = (store: Store, shareDisplayItems?: SiteDisplayItemsExtend) => {
	const isFirst = !shareDisplayItems;
	const [displayItems, setDisplayItems] = useState<SiteDisplayItemsExtend>(isFirst ? initialValues : shareDisplayItems);
	const [getSiteDisplayItemLoading, setGetSiteDisplayItemLoading] = useState(false);
	useEffect(() => {
		if (!isFirst) {
			return;
		}

		const execute = async () => {
			setGetSiteDisplayItemLoading(true);

			let siteCd = '';
			if (store.registerUserData.isV1ParamsOk) {
				siteCd = store.authorizeV1Data.scd;
			} else if (store.registerUserData.isV2ParamsOk) {
				siteCd = store.authorizeV2Data.client_id;
			}
			const result = await callGetSiteDisplayItemsApi(siteCd);
			if (result.status === HttpStatus.OK) {
				setDisplayItems({
					isSkip3_2: isHidden3_2AllItem(result.data),
					password_confirm: result.data.pass,
					birthYear: result.data.birth,
					birthMonth: result.data.birth,
					birthDate: result.data.birth,
					...result.data,
				});
			}
			setGetSiteDisplayItemLoading(false);
		};
		execute();
	}, []);

	const isRequired = (num: number) => {
		return REQUIRED === num;
	};
	const isOptional = (num: number) => {
		return OPTIONAL === num;
	};
	const isNone = (num: number) => {
		return NONE === num;
	};

	return {
		displayItems,
		isRequired,
		isOptional,
		isNone,
		getSiteDisplayItemLoading,
	};
};

/*
 * 1：表示＆必須入力
 * 2：表示＆任意入力
 * 3：非表示
 * 0：未使用（エラー）
 */
const REQUIRED = 1;
const OPTIONAL = 2;
const NONE = 3;
const ERROR = 0;

const initialValues = {
	isSkip3_2: false,
	// 3-1
	password_confirm: REQUIRED,
	birthYear: REQUIRED,
	birthMonth: REQUIRED,
	birthDate: REQUIRED,
	gid: REQUIRED,
	pass: REQUIRED,
	mailaddress_1: REQUIRED,
	lastname: REQUIRED,
	firstname: REQUIRED,
	kana_lastname: OPTIONAL,
	kana_firstname: OPTIONAL,
	birth: REQUIRED,
	sex: OPTIONAL,
	directmail_flg: REQUIRED,
	data_util_agree_flg: NONE,
	// 3-2
	tel: OPTIONAL,
	zip: OPTIONAL,
	pref_cd: OPTIONAL,
	address_2: OPTIONAL,
	address_3: OPTIONAL,
	address_4: OPTIONAL,
	nickname: OPTIONAL,
	country: OPTIONAL,
	// ここから不使用項目
	id: REQUIRED,
	search_site_cd: '',
	search_family_type: REQUIRED,
	search_screen_id: 'GIDP234',
	mailaddress_2: NONE,
	mailaddress_3: NONE,
	mobile: NONE,
	address_5: NONE,
	address_6: NONE,
	family_cd: NONE,
	family_type: NONE,
	payment_not_flg: NONE,
	withdrawal_flg: NONE,
	regist_ts: NONE,
	update_ts: NONE,
	tel_2: NONE,
	ext_1: NONE,
	ext_2: NONE,
	ext_3: NONE,
};

// 3-2ページの項目がすべて非表示（orエラー）かどうか
const isHidden3_2AllItem = (siteDisplayItems: SiteDisplayItems) => {
	const itemNames = ['tel', 'zip', 'pref_cd', 'address_2', 'address_3', 'address_4', 'nickname', 'country'];

	const result = Object.entries(siteDisplayItems)
		.filter((s) => itemNames.includes(s[0]))
		.every((s) => [NONE, ERROR].includes(Number(s[1])));

	return result;
};
